module.exports = __webpack_public_path__ + "static/media/ListadoCustomer.5e743257.PNG";